import { Paper, Typography, useTheme } from '@mui/material';
import type { NarrativeBlockData } from '../../types';
import TileMetaActions from '../TileMetaActions';
import { tileMetaTitlePad } from '../../utils/tileMeta';

type Props = { data: NarrativeBlockData };

export default function NarrativeBlockRenderer({ data }: Props) {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        width: '100%',
        position: 'relative',
      }}
    >
      <TileMetaActions query={data.meta?.query} registry={data.meta?.registry} />
      {data.overline ? (
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 700,
            color: 'text.secondary',
            letterSpacing: '0.07em',
            textTransform: 'uppercase',
            mb: 1,
            pr: tileMetaTitlePad(data.meta),
          }}
        >
          {data.overline}
        </Typography>
      ) : null}
      {data.headline ? (
        <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary', mb: 1, lineHeight: 1.35 }}>
          {data.headline}
        </Typography>
      ) : null}
      {data.description ? (
        <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
          {data.description}
        </Typography>
      ) : null}
    </Paper>
  );
}
